module.exports = __webpack_public_path__ + "img/search-delete.14c627f7.svg";